import script from "./VisualsLibraryTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualsLibraryTab.vue?vue&type=script&setup=true&lang=js"

import "./VisualsLibraryTab.vue?vue&type=style&index=0&id=a85b915e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a85b915e"]])

export default __exports__